/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ClassSignupInstructorEligibilityStatus = {
  Ineligible: "INELIGIBLE",
  Eligible: "ELIGIBLE",
  Enrolled: "ENROLLED",
} as const;

export type ClassSignupInstructorEligibilityStatus =
  (typeof ClassSignupInstructorEligibilityStatus)[keyof typeof ClassSignupInstructorEligibilityStatus];

export type ClassSignupInstructorEligibilityStatusEnumType =
  typeof ClassSignupInstructorEligibilityStatus;
export type ClassSignupInstructorEligibilityStatusOptional =
  ClassSignupInstructorEligibilityStatus;
export type ClassSignupInstructorEligibilityStatusTrackedI =
  ClassSignupInstructorEligibilityStatus;
export type ClassSignupInstructorEligibilityStatusTracked =
  ClassSignupInstructorEligibilityStatus;
export type ClassSignupInstructorEligibilityStatusMetaI = EnumMetaType<
  ClassSignupInstructorEligibilityStatusEnumType,
  ClassSignupInstructorEligibilityStatus
>;
export const ClassSignupInstructorEligibilityStatusMeta = typeMetaEnum<
  ClassSignupInstructorEligibilityStatusEnumType,
  ClassSignupInstructorEligibilityStatus
>(
  "ClassSignupInstructorEligibilityStatus",
  ClassSignupInstructorEligibilityStatus,
);
export function transformDatesClassSignupInstructorEligibilityStatus(
  model: ClassSignupInstructorEligibilityStatus,
) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
